<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16">
  <path
    d="M16,9.75v-5H8.813V6.688H4.063V5H7.188V0H0V5H2.813v9.188h6V16H16V11H8.813v1.938H4.063v-5h4.75V9.75ZM1.25,1.25H5.938v2.5H1.25Zm8.813,11H14.75v2.5H10.063Zm0-6.25H14.75V8.5H10.063Zm0,0"
    fill="#8693ad"
  />
</svg>
